module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "follow"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a-progressbar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "f-head clearfix"
  }, [_c('h4', {
    staticClass: "fl"
  }, [_vm._v("追的番剧")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right fr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v("您还没有在追的番剧哦 ~")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/img/follow-pic.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f575b08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/follow.vue
// module id = 105
// module chunks = 0